import { useEffect, useState } from "react";
import { useHome } from "../../../hooks/useHome";

export const Timeline = () => {
    const { lineaTiempo, timelineContent, timelineWidth, getTimelineContent, getWidthTimeline, getLinea, toggleElementActive, numElement, isElementActive } = useHome();

    useEffect(() => {
        getLinea();
    }, []);



    return (
        <div className="bg-morado d-flex flex-column align-items-center" role="navigation">

            <div style={{ maxWidth: "90%" }}>


                <div className="container-fluid container-timelapse">

                    <div className="row">

                        <div className="col-md-12 d-flex position-relative linea-container justify-content-center">

                            {lineaTiempo?.map(({ id, texto, anio }, i) => (
                                <div
                                    role="button"
                                    aria-label={`Año ${anio}`}
                                    key={id}
                                    className={`step step${numElement(i)}  ${isElementActive(i) ? 'active' : ''}`}
                                    onClick={() => {
                                        getWidthTimeline(i);
                                        getTimelineContent(texto);
                                        toggleElementActive(i);
                                    }}>
                                    <svg
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="globo">
                                        <style type="text/css">
                                            {`.st1 { fill: #FFFFFF; }`}
                                        </style>
                                        <path className="globo" d="M85,42.5C85,19,66,0,42.5,0S0,19,0,42.5c0,18,11.2,33.4,27,39.6l13.3,17.8c0.8,1.1,2.5,1.1,3.3,0l12.9-17.2 C73.1,76.8,85,61,85,42.5z" />
                                        <circle className="st1" cx="42.5" cy="43.5" r="24" />
                                        <circle className="globo" cx="42" cy="113" r="6" />
                                    </svg>
                                    <div className="step-inner fecha-step fw-bold">{anio}</div>
                                </div>
                            ))}

                            <div id="linea">
                                <div id="progreso-linea" style={{ width: `${timelineWidth}%` }}></div>
                            </div>
                        </div>
                    </div>

                </div>



            </div>

            <div className="container-fluid" role="contentinfo" aria-label="la transparencia a través del tiempo">
                <div className="row">
                    <p className="titulo-timeline">
                        LA TRANSPARENCIA EN MÉXICO A TRAVES DEL TIEMPO
                    </p>
                    <div id="progress-content-section">
                        <div className="section-content active">
                            <p>
                                {timelineContent}
                            </p>
                        </div>

                    </div>
                </div>
            </div>










        </div>
    );
};
